const userLang = navigator.language || navigator.userLanguage;
export let lang;

if (userLang.startsWith("en")) {
  lang = 0; // English
} else if (userLang.startsWith("de")) {
  lang = 1; // German
} else if (userLang.startsWith("fr")) {
  lang = 2; // French
} else {
  lang = 0; // Default to English for any other language
}

// All French translations are LLM-generated.

export const NameOfTheGame = [
  "Divide et Impera",
  "Divide et Impera",
  "Divide et Impera"
][lang];
export const SubtitleOfTheGame = [
  "A learning environment for the practice book \"Mathematik entdecken und entwickeln - Band 5: Von der Subtraktion zur Division\"",
  "Eine Lernumgebung zum Praxisbuch \"Mathematik entdecken und entwickeln - Band 5: Von der Subtraktion zur Division\"",
  "Un environnement d'apprentissage pour le manuel pratique \"Mathematik entdecken und entwickeln - Band 5: Von der Subtraktion zur Division\""
][lang];

// Screens
export const AppScreenSize = [
  "Your screen size is too small. Please use a larger screen to access this website.",
  "Dein Bildschirm ist zu klein. Bitte nutze einen grösseren Bildschirm.",
  "La taille de ton écran est trop petite. S'il te plaît, utilise un écran plus grand pour accéder à ce site web.",
][lang];
export const AppRotateScreen = [
  "Please rotate your screen.",
  "Bitte drehe deinen Bildschirm.",
  "S'il te plaît, fais pivoter ton écran.",
][lang];

// Generic
export const answerYes = ["Yes", "Ja", "Oui"][lang];
export const answerNo = ["No", "Nein", "Non"][lang];

// InputBox.jsx
export const InputBoxResult = ["Result", "Resultat", "Résultat"][lang];
export const InputBoxRemainder = ["Rem.", "Rest", "Reste"][lang];
export const InputBoxCheck = ["Check", "Prüfen", "Vérifie"][lang];

// ChooseSystemPopup.jsx
export const ChooseSystemPopupRoman = ["Old Roman", "Altrömisch", "Romain Ancien"][lang];
export const ChooseSystemPopupBinary = ["Binary", "Binär", "Binaire"][lang];
export const ChooseSystemPopupMaya = ["Maya", "Maya", "Maya"][lang];
export const ChooseSystemPopupMessage = [
  "Choose the numeral system that you want to use:",
  "Wähle das Zahlensystem aus, das du benutzen möchtest:",
  "Choisis le système de numération que tu souhaites utiliser :",
][lang];

// NewGamePopup.jsx
export const NewGamePopupNewGame = ["New Game", "Neues Spiel", "Nouvelle Partie"][lang];
export const NewGamePopupContinueGame = ["Continue Game", "Spiel fortsetzen", "Continuer la Partie"][lang];
export const NewGamePopupConfirmation1 = [
  "A save already exists on this device. If you press 'Yes', the save will be deleted and a new game starts.",
  "Es existiert bereits ein Spielstand auf diesem Gerät. Wenn du auf 'Ja' drückst, wird er gelöscht und ein neues Spiel beginnt.",
  "Une sauvegarde existe déjà sur cet appareil. Si tu appuies sur 'Oui', la sauvegarde sera supprimée et une nouvelle partie commencera.",
][lang];
export const NewGamePopupConfirmation2 = [
  "Do you want to continue?",
  "Willst du fortfahren?",
  "Veux-tu continuer ?",
][lang];

// InformationPopup.jsx
export const informationPopupTitle = [
  "Information",
  "Information",
  "Information"
][lang];
export const informationPopupBackground1 = [
  "This learning environment serves as a supplementary teaching resource for the practice book ",
  "Diese Lernumgebung dient als ergänzendes Lehrmittel zum Praxisbuch ",
  "Cet environnement d'apprentissage sert de ressource pédagogique complémentaire pour le manuel pratique "
][lang];
export const informationPopupBackground2 = [
  "Mathematik entdecken und entwickeln - Band 5: Von der Subtraktion zur Division",
  "Mathematik entdecken und entwickeln - Band 5: Von der Subtraktion zur Division",
  "Mathematik entdecken und entwickeln - Band 5: Von der Subtraktion zur Division"
][lang];
export const informationPopupBackground3 = [
  " and was developed as part of a bachelor's thesis at ETH Zurich.",
  " und wurde im Rahmen einer Bachelorarbeit an der ETH Zürich entwickelt.",
  " et a été développé dans le cadre d'un travail de bachelor à l'ETH Zurich."
][lang];
export const informationPopupTechnical = [
  "Supports all common browsers on desktop PCs and tablets. Does not support smartphones.",
  "Unterstützt alle gängigen Browser auf Desktop-PCs sowie auf Tablets. Unterstützt keine Smartphones.",
  "Prend en charge tous les navigateurs courants sur les ordinateurs de bureau ainsi que sur les tablettes. Ne prend pas en charge les smartphones."
][lang];
export const informationPopupDeveloper = [
  "Developer: Lukas Sogor",
  "Entwickler: Lukas Sogor",
  "Développeur : Lukas Sogor"
][lang];
export const informationPopupCredits1 = [
  "Credits:",
  "Credits:",
  "Crédits :"
][lang];
export const informationPopupCredits2 = [
  "The structure of this game is based on the ",
  "Die Struktur dieses Spiels baut auf der ",
  "La structure de ce jeu est basée sur "
][lang];
export const informationPopupCredits3 = [
  "learning environment by Jonas Leuthold",
  "Lernumgebung von Jonas Leuthold",
  "l'environnement d'apprentissage de Jonas Leuthold"
][lang];
export const informationPopupCredits4 = [
  ".",
  " auf.",
  "."
][lang];
export const informationPopupCredits5 = [
  "Info icon created by ",
  "Info-Icon erstellt von ",
  "Icône d'information créée par "
][lang];
export const informationPopupCredits6 = [
  "Freepik",
  "Freepik",
  "Freepik"
][lang];
export const informationPopupCredits7 = [
  ", uploaded to ",
  ", hochgeladen auf ",
  ", téléchargé sur "
][lang];
export const informationPopupCredits8 = [
  "Flaticon",
  "Flaticon",
  "Flaticon"
][lang];
export const informationPopupCredits9 = [
  ".",
  ".",
  "."
][lang];

// Introduction.jsx
export const introductionTitle = [
  "Introduction",
  "Einführung",
  "Introduction",
][lang];
export const introduction1 = [
  "In this game, you will learn division using non-decimal numeral systems. The basic principle, however, is the same.",
  "In diesem Spiel lernst du das Teilen mit Zahlen, die keine Dezimalzahlen sind. Das Grundprinzip ist aber das Gleiche.",
  "Dans ce jeu, tu apprendras la division en utilisant des systèmes de numération non décimaux. Le principe de base, cependant, est le même.",
][lang];
export const introduction2 = [
  "In this game, there are three numeral systems: old Roman numerals, binary numbers, and 'Mayan' hieroglyphs.",
  "Es gibt in diesem Spiel drei Zahlendarstellungen: Altrömische Zahlen, binäre Zahlen und 'Maya'-Hieroglyphen.",
  "Dans ce jeu, il y a trois systèmes de numération : les anciens chiffres romains, les nombres binaires et les hiéroglyphes 'Mayas'.",
][lang];
export const introduction3 = [
  "A little note on the old Roman numerals for those familiar with them:",
  "Kleine Anmerkung zu den altrömischen Zahlen für diejenigen, die sie schon kennen:",
  "Petite note sur les anciens chiffres romains pour ceux qui les connaissent :",
][lang];
export const introduction4 = [
  "In this game, 4 is not IV but IIII, and 9 is not IX but VIIII and so on.",
  "In diesem Spiel ist 4 nicht IV sondern IIII, und 9 ist nicht IX sondern VIIII und so weiter.",
  "Dans ce jeu, 4 n'est pas IV mais IIII, et 9 n'est pas IX mais VIIII, etc.",
][lang];
export const introduction5 = [
  "The game proceeds as follows:",
  "Der Ablauf des Spiels ist wie folgt:",
  "Le jeu se déroule comme suit :",
][lang];
export const introduction6 = [
  "There are several levels. First, there will always be an explanation of the level. Then it begins.",
  "Es gibt mehrere Levels. Es wird immer zuerst einen Hinweis geben, der das Level erklärt. Dann geht es los.",
  "Il y a plusieurs niveaux. D'abord, il y aura toujours une explication du niveau. Puis cela commence.",
][lang];
export const introduction7 = [
  "To unlock the next level, you must solve at least three problems in the previous level. There are a few exceptions to this rule, but you will always be notified of them.",
  "Um das nächste Level freizuschalten, musst du mindestens drei Aufgaben im vorigen Level gelöst haben. Zu dieser Regel gibt es wenige Ausnahmen; auf diese wirst du aber immer hingewiesen.",
  "Pour débloquer le niveau suivant, tu dois résoudre au moins trois problèmes du niveau précédent. Il y a quelques exceptions à cette règle, mais tu en seras toujours informé.",
][lang];
export const introduction8 = [
  "Once you've unlocked the next level, you decide whether you want to move on to it right away or stay a little longer in the current one.",
  "Wenn du das nächste Level freigeschaltet hast, entscheidest du, ob du schon zum nächsten Level willst oder noch bleibst.",
  "Une fois que tu as débloqué le niveau suivant, c'est à toi de décider si tu veux y passer tout de suite ou si tu préfères rester encore un peu au niveau actuel."
][lang];
export const introduction9 = [
  "You can switch between unlocked levels at any time by clicking the arrows or the level buttons at the bottom.",
  "Du kannst jederzeit zwischen freigeschalteten Levels wechseln, indem du unten auf die Pfeile oder die Levelknöpfe drückst.",
  "Tu peux changer de niveau à tout moment parmi ceux que tu as débloqués, en cliquant sur les flèches ou sur les boutons de niveau en bas."
][lang];
export const introduction10 = [
  "Now choose the number represenation that you want to start with. You can change it at any time.",
  "Wähle nun die Zahlendarstellung, mit der du anfangen willst. Du kannst sie jederzeit ändern.",
  "Choisis maintenant la représentation numérique avec laquelle tu veux commencer. Tu peux la changer à tout moment.",
][lang];
export const introduction11 = [
  "Happy learning!",
  "Gutes Lernen!",
  "Bon apprentissage !",
][lang];

// Generic Level-Unlocked Strings
export const levelUnlockedTitle = [
  "Congratulations!",
  "Glückwunsch!",
  "Félicitations !",
][lang];
export const levelUnlockedBody1 = [
  "You've unlocked the next level.",
  "Du hast das nächste Level freigeschaltet.",
  "Tu as débloqué le niveau suivant.",
][lang];
export const levelUnlockedBody2 = [
  "Do you want to go to the next level or would you rather continue playing this level for now?",
  "Willst du zum nächsten Level gehen oder lieber noch dieses Level weiterspielen?",
  "Veux-tu passer au niveau suivant ou préfères-tu continuer à jouer à ce niveau pour l'instant ?",
][lang];
export const levelUnlockedBodyLastLevel1 = [
  "You've solved all levels of this numeral system!",
  "Du hast alle Level dieses Zahlensystems gelöst!",
  "Tu as résolu tous les niveaux de ce système de numération !",
][lang];
export const levelUnlockedBodyLastLevel2 = [
  "Very well done.",
  "Das ist eine klasse Leistung.",
  "Très bien joué.",
][lang];
export const levelUnlockedBodyLastLevel3 = [
  "If you want, you can play through the levels of the other numeral systems as well in order to become a true master.",
  "Wenn du willst, kannst du nun auch noch die Levels der anderen Zahlensysteme lösen, um ein echter Meister zu werden.",
  "Si tu le souhaites, tu peux également parcourir les niveaux des autres systèmes de numération afin de devenir un véritable maître.",
][lang];
export const levelUnlockedBodyOneExercise = [
  "This level only had one exercise, and so you will immediately move on to the next level.",
  "Dieses Level hatte nur eine Aufgabe, daher geht es nun direkt weiter zum nächsten Level.",
  "Ce niveau ne comportait qu'un seul exercice, tu passeras donc immédiatement au niveau suivant.",
][lang];
export const levelUnlockedBodyCompletedGame1 = [
  "You've finished the entire game!",
  "Du hast das ganze Spiel durchgespielt!",
  "Tu as terminé le jeu entier !",
][lang];
export const levelUnlockedBodyCompletedGame2 = [
  "There is nothing more to do.",
  "Es gibt nichts mehr zu tun.",
  "Il n'y a plus rien à faire.",
][lang];
export const levelUnlockedBodyCompletedGame3 = [
  "Except maybe...",
  "Ausser vielleicht...",
  "Sauf peut-être...",
][lang];
export const levelUnlockedEasterEgg = [
  "?",
  "?",
  "?",
][lang];
export const levelUnlockedStay = [
  "Stay here for now",
  "Noch hier bleiben",
  "Rester ici pour l'instant",
][lang];
export const levelUnlockedContinue = [
  "Go to next level",
  "Zum nächsten Level",
  "Passer au niveau suivant",
][lang];


// Beta Testing Strings
export const betaTest1 = [
  "Dear beta tester,",
  "Lieber Betatester",
  "Cher bêta-testeur,",
][lang];
export const betaTest2 = [
  "thank you for taking the time to try out this game! Please note that only the following browsers are supported:",
  "Danke, dass du dir die Zeit nimmst, dieses Spiel auszuprobieren! Bitte beachte, dass nur die folgenden Browser unterstützt werden:",
  "Merci de prendre le temps d'essayer ce jeu ! S'il te plaît, note que seuls les navigateurs suivants sont pris en charge :",
][lang];
export const betaTest3 = [
  "Edge, Chrome, Firefox, Safari.",
  "Edge, Chrome, Firefox, Safari.",
  "Edge, Chrome, Firefox, Safari.",
][lang];

// Generic Buttons
export const buttonCheck = [
  "Check",
  "Prüfen",
  "Vérifie",
][lang];
export const buttonContinue = [
  "Okay",
  "Weiter",
  "Continue",
][lang];
export const buttonCheckLine = [
  "Check line",
  "Zeile prüfen",
  "Vérifie la ligne",
][lang];
export const buttonChangeSystem = [
  "Change numeral system",
  "Zahlensystem wechseln",
  "Changer de système de numération",
][lang];
export const buttonShowTutorial = [
  "Help",
  "Hilfe",
  "Aide",
][lang];
export const buttonShowLegend = [
  "Legend of symbols",
  "Zeichenerklärung",
  "Légende des symboles",
][lang];

// Generic level strings.
export const levelNoInput = [
  "Enter a number first!",
  "Gib zuerst eine Zahl ein!",
  "Entre d'abord un nombre !",
][lang];
export const levelNoInputMulti = [
  "Fill in all fields first!",
  "Fülle zuerst alle Felder ein!",
  "Remplis d'abord tous les champs !",
][lang];
export const levelIncorrect = [
  "Not quite right.",
  "Stimmt nicht ganz.",
  "Pas tout à fait correct.",
][lang];
export const levelCorrect = [
  "Very good, keep it up!",
  "Sehr gut, weiter so!",
  "Très bien, continue !",
][lang];
export const levelExchange = ["Exchange", "Tauschen", "Échanger"][lang];
export const levelDivisionTask1 = ["What is ", "Was gibt ", "Qu'est-ce que donne "][lang];
export const levelDivisionTask2 = [" divided by ", " geteilt durch ", " divisé par "][lang];
export const levelDivisionTaskBoxes = [
  "Distribute the coins equally between the boxes to find out.",
  "Verteile die Münzen gleichmässig auf alle Boxen und finde es heraus.",
  "Distribue équitablement les pièces entre les boîtes pour le découvrir.",
][lang];
export const levelWrongNotDistributed =
  levelIncorrect + [" Distribute the coins!", " Verteile die Münzen!", " Distribue les pièces !"][lang];
export const levelWrongDistributed =
  levelIncorrect +
  [
    " The result is what each box has received.\n The remainder is what's left over.",
    " Das Resultat ist das, was jede Box bekommen hat.\n Der Rest ist, was übrig bleibt.",
    " Le résultat est ce que chaque boîte a reçu.\n Le reste est ce qui reste.",
  ][lang];
export const levelNotEnoughCoins = [
  "You do not have enough of these coins!",
  "Du hast nicht genug von diesen Münzen!",
  "Tu n'as pas assez de ces pièces !",
][lang];
export const levelExchangeCoins =
  levelNotEnoughCoins.slice(0, -1) +
  [", exchange them!", ", tausche sie um!", ", échange-les !"][lang];
export const levelWrongBox = [
  "Drop the coin into another box.",
  "Gib erst einmal den anderen Boxen mehr Münzen.",
  "Dépose la pièce dans une autre boîte.",
][lang];
export const levelExchangeTooSmall = [
  "These coins are too small to be exchanged!",
  "Diese Münzen sind zu klein, um sie zu tauschen!",
  "Ces pièces sont trop petites pour être échangées !",
][lang];
export const levelExchangeTooMany = [
  "You still have too many coins to exchange them!",
  "Du hast noch zu viele Münzen, um zu tauschen!",
  "Tu as encore trop de pièces pour les échanger !",
][lang];
export const allLevelsCompletedRoman = [
  " Congratulations! You have completed all old Roman levels.",
  " Glückwunsch! Du hast alle altrömischen Level abgeschlossen.",
  " Félicitations ! Tu as terminé tous les niveaux romains anciens.",
][lang];
export const allLevelsCompletedBinary = [
  " Congratulations! You have completed all binary levels.",
  " Glückwunsch! Du hast alle binären Level abgeschlossen.",
  " Félicitations ! Tu as terminé tous les niveaux binaires.",
][lang];
export const allLevelsCompletedMaya = [
  " Congratulations! You have completed all Maya levels.",
  " Glückwunsch! Du hast alle Maya-Level abgeschlossen.",
  " Félicitations ! Tu as terminé tous les niveaux Mayas.",
][lang];

// Table Division Levels
export const levelTableDivisionSolveGridFirst = [
  "\n Solve the grid puzzle to get the solution.",
  "\n Löse das Tabellenrätsel, um die Lösung zu erhalten.",
  "\n Résous le puzzle de la grille pour obtenir la solution.",
][lang];
export const levelTableDivisionTitleLeft = [
  "To Distribute:",
  "Zu Verteilen:",
  "À Distribuer :",
][lang];
export const levelTableDivisionTitleRight = [
  "Distributed:",
  "Verteilt:",
  "Distribué :",
][lang];
export const levelTableDivisionAction = ["Action:", "Aktion:", "Action :"][lang];

// Level0Roman.jsx
export const level0RomanTask1 = [
  "Convert the old Roman number ",
  "Wandle die altrömische Zahl ",
  "Convertis le nombre romain ancien ",
][lang];
export const level0RomanTask2 = [
  " to a decimal number.",
  " in eine Dezimalzahl um.",
  " en nombre décimal.",
][lang];

// Level1Roman.jsx
export const level1RomanTask1 = [
  "Convert the decimal number ",
  "Wandle die Dezimalzahl ",
  "Convertis le nombre décimal ",
][lang];
export const level1RomanTask2 = [
  " to an old Roman number.",
  " in eine altrömische Zahl um.",
  " en nombre romain ancien.",
][lang];

// Level2Roman.jsx
export const level2RomanDropLargerFirst = [
  "Distribute the larger coins first!",
  "Verteile zuerst die grösseren Münzen!",
  "Distribue d'abord les plus grosses pièces !",
][lang];

// Level4Roman.jsx
export const level4RomanInputs = [
  "The inputs must be the same in both rows!",
  "Die Eingaben müssen in beiden Zeilen übereinstimmen!",
  "Les entrées doivent être les mêmes dans les deux lignes !",
][lang];
export const level4RomanRemainders = [
  "The remainders must be the same in both rows!",
  "Die Reste in beiden Zeilen müssen übereinstimmen!",
  "Les restes doivent être les mêmes dans les deux lignes !",
][lang];
export const level4RomanRemainderSmaller1 = [
  "The remainder has to be smaller than the ",
  "Der Rest muss kleiner als der ",
  "Le reste doit être plus petit que le ",
][lang];
export const level4RomanRemainderSmaller2 = ["divisor", "Divisor", "diviseur"][lang];
export const level4RomanRemainderSmaller3 = [".", " sein.", "."][lang];

// Level0Binary.jsx
export const level0BinaryTask1 = [
  "Convert the binary number ",
  "Wandle die Binärzahl ",
  "Convertis le nombre binaire ",
][lang];
export const level0BinaryTask2 = [
  " to a decimal number.",
  " in eine Dezimalzahl um.",
  " en nombre décimal.",
][lang];

// Level1Binary.jsx
export const level1BinaryNoneDropped = [
  "Drag at least one coin into the box first!",
  "Ziehe zuerst mindestens eine Münze in die Box!",
  "Glisse d'abord au moins une pièce dans la boîte !",
][lang];
export const level1BinaryTask1 = [
  "Pay the amount ",
  "Bezahle den Betrag ",
  "Paie le montant ",
][lang];
export const level1BinaryTask2 = [
  " with the smallest possible number of binary coins.",
  " mit der kleinstmöglichen Anzahl binärer Münzen.",
  " avec le plus petit nombre possible de pièces binaires.",
][lang];
export const level1BinaryInfoText = [
  "We don't write down leading zeros in binary representation!",
  "Führende Nullen (Nullen, die ganz links stehen würden) schreiben wir in Binärdarstellung nicht auf!",
  "Nous n'écrivons pas les zéros de tête en représentation binaire !",
][lang];
export const level1BinaryNote = [
  "Note: ",
  "Beachte: ",
  "Remarque : ",
][lang];

// Level2Binary.jsx
export const level2BinaryDistribute = [
  "Distribute",
  "Verteilen",
  "Distribuer",
][lang];
export const level2BinaryContinueDistributing = [
  "Before you exchange, all boxes should contain the same amount of coins!",
  "Bevor du umtauschst, sollten alle Boxen gleich viele Münzen enthalten!",
  "Avant d'échanger, toutes les boîtes doivent contenir le même nombre de pièces !",
][lang];
export const level2BinaryNoLeadingZeros = [
  "We don't allow leading zeros in binary representation.",
  "In der Binärdarstellung sind keine führenden Nullen erlaubt.",
  "Nous n'autorisons pas les zéros de tête en représentation binaire.",
][lang];

// Level4Binary.jsx
export const level4BinaryTask = [
  "Multiply the binary number in each row by 2.",
  "Rechne die binäre Zahl in jeder Zeile mal 2.",
  "Multiplie le nombre binaire de chaque ligne par 2.",
][lang];
export const level4BinaryTextBoxNotice = [
  "Do you notice something?\n",
  "Fällt dir etwas auf?\n",
  "Remarques-tu quelque chose ?\n",
][lang];
export const level4BinaryTextBox1 = [
  "When multiplying by 2, all zeros and ones shift to the ",
  "Beim Mal-2 rechnen rücken alle Nullen und Einsen einmal nach ",
  "En multipliant par 2, tous les zéros et uns se décalent vers la ",
][lang];
export const level4BinaryTextBox2 = [
  " and on the ",
  " und ganz ",
  " et à l'extrémité ",
][lang];
export const level4BinaryTextBox3 = [
  " end there is always a ",
  " steht immer eine ",
  " il y a toujours un ",
][lang];
export const level4BinaryTextBoxLeft = [
  "left",
  "links",
  "gauche",
][lang];
export const level4BinaryTextBoxRight = [
  "right",
  "rechts",
  "droite",
][lang];
export const level4BinaryTextBoxZero = [
  "zero",
  "Null",
  "zéro",
][lang];
export const level4BinaryTextBoxOne = [
  "one",
  "Eins",
  "un",
][lang];
export const level4BinaryTextBoxChoose = [
  "",
  "",
  "",
][lang];
export const level4BinaryTextBoxProperty = [
  "This trick only works for the number 2. It is a special property of the binary system.",
  "Dieser Trick funktioniert nur mit der Zahl 2. Dies ist eine spezielle Eigenschaft des Binärsystems.",
  "Cette astuce ne fonctionne que pour le nombre 2. C'est une propriété spéciale du système binaire.",
][lang];

// Level5Binary.jsx
export const level5BinaryTask = [
  "Divide the binary number in each row by 2.",
  "Teile die binäre Zahl in jeder Zeile durch 2.",
  "Divise le nombre binaire de chaque ligne par 2.",
][lang];
export const level5BinaryTextBox1 = [
  "When dividing by 2, all zeros and ones shift to the ",
  "Beim Teilen durch 2 rücken alle Nullen und Einsen einmal nach ",
  "En divisant par 2, tous les zéros et uns se décalent vers la ",
][lang];
export const level5BinaryTextBox3 = [
  " end there would always be a zero.",
  " würde immer eine Null stehen.",
  " il y aurait toujours un zéro.",
][lang];
export const level5BinaryTextBox4 = [
  "But remember: ",
  "Aber erinnere dich: ",
  "Mais souviens-toi : ",
][lang];
export const level5BinaryTextBox5 = [
  "We usually don't write down leading zeros.",
  "Führende Nullen schreiben wir normalerweise nicht auf.",
  "Nous n'écrivons généralement pas les zéros de tête.",
][lang];

// Level6Binary.jsx
export const level6BinaryTask = [
  "Divide the binary number by 2 using the trick you just learned.",
  "Teile die binäre Zahl durch 2 mithilfe des Tricks, den du gerade gelernt hast.",
  "Divise le nombre binaire par 2 en utilisant l'astuce que tu viens d'apprendre.",
][lang];
export const level6BinaryTextBox = [
  "Remember that we don't write down leading zeros!",
  "Denk daran, dass wir führende Nullen gar nicht erst aufschreiben!",
  "N'oublie pas que nous n'écrivons pas les zéros de tête !",
][lang];

// Maya Division Levels
export const levelMayaWriteDivision = [
  "Now write down the division using decimal numbers:",
  "Schreibe nun die Division in der Dezimaldarstellung auf:",
  "Maintenant, écris la division en utilisant les nombres décimaux :",
][lang];
export const levelMayaDivisionWelcome1 = [
  "What is the result of ",
  "Was gibt ",
  "Quel est le résultat de ",
][lang];
export const levelMayaDivisionWelcome2 = [
  " divided by ",
  " geteilt durch ",
  " divisé par ",
][lang];
export const levelMayaDivisionWelcome3 = [
  " ?",
  " ?",
  " ?",
][lang];
export const levelMayaDivisionWelcome4 = [
  "Distribute the Maya items equally between the boxes to find out.",
  "Verteile die Maya-Gegenstände gleichmässig auf alle Boxen und finde es heraus.",
  "Répartis équitablement les objets Mayas entre les boîtes pour le découvrir.",
][lang];

// Level0Maya.jsx
export const level0MayaTask = [
  "Convert the hieroglyphs into a decimal number.",
  "Wandle die Hieroglyphen in eine Dezimalzahl um.",
  "Convertis les hiéroglyphes en nombre décimal.",
][lang];

// Level1Maya.jsx
export const level1MayaTask1 = [
  "Represent the number ",
  "Stelle die Zahl ",
  "Représente le nombre ",
][lang];
export const level1MayaTask2 = [
  " using hieroglyphs.",
  " als Hieroglyphen dar.",
  " en utilisant des hiéroglyphes.",
][lang];
export const level1MayaNoneDropped = [
  "Drag at least one item into the box first!",
  "Ziehe zuerst mindestens einen Gegenstand in die Box!",
  "Glisse d'abord au moins un objet dans la boîte !",
][lang];

// Level2Maya.jsx
export const level2MayaDropLargerFirst = [
  "Distribute the larger items first!",
  "Verteile zuerst die grösseren Gegenstände!",
  "Distribue d'abord les plus gros objets !",
][lang];
export const level2MayaNotEnoughItems = [
  "You do not have enough of these items!",
  "Du hast nicht genug von diesen Gegenständen!",
  "Tu n'as pas assez de ces objets !",
][lang];
export const level2MayaExchangeItems =
  level2MayaNotEnoughItems.slice(0, -1) +
  [", exchange them!", ", tausche sie um!", ", échange-les !"][lang];
export const level2MayaWrongBox = [
  "Drop the item into another box first.",
  "Gib erst einmal den anderen Boxen mehr Gegenstände.",
  "Dépose d'abord l'objet dans une autre boîte.",
][lang];
export const level2MayaExchangeTooSmall = [
  "These items are too small to be exchanged!",
  "Diese Gegenstände sind zu klein, um sie zu tauschen!",
  "Ces objets sont trop petits pour être échangés !",
][lang];
export const level2MayaContinueDistributing = [
  "Before you exchange, all boxes should contain the same amount of items!",
  "Bevor du umtauschst, sollten alle Boxen gleich viele Gegenstände enthalten!",
  "Avant d'échanger, toutes les boîtes doivent contenir le même nombre d'objets !",
][lang];
export const level2MayaTooMany = [
  "You still have too many items to exchange them!",
  "Du hast noch zu viele Gegenstände, um zu tauschen!",
  "Tu as encore trop d'objets pour les échanger !",
][lang];
export const level2MayaWrongNotDistributed =
  levelIncorrect + [" Distribute the items!", " Verteile die Gegenstände!", " Distribue les objets !"][lang];
export const level2MayaWrongDistributed =
  levelIncorrect + [
  " The first entry is which number we are dividing.\n The second entry is what each box contains in the end.",
  " Das erste Eingabefeld enthält die Zahl, die wir teilen wollen.\n Das zweite Eingabefeld soll angeben, was jede Box am Ende enthält.",
  " La première entrée est le nombre que nous divisons.\n La deuxième entrée est ce que chaque boîte contient à la fin.",
][lang];

// Level3Maya.jsx
export const level3MayaWrongDistributed =
  levelIncorrect + [
  " The first entry is which number we are dividing.\n The second entry is what each box contains in the end.\n The remainder is what's left over.",
  " Das erste Eingabefeld enthält die Zahl, die wir teilen wollen.\n Das zweite Eingabefeld soll angeben, was jede Box am Ende enthält. Der Rest ist, was übrig bleibt.",
  " La première entrée est le nombre que nous divisons.\n La deuxième entrée est ce que chaque boîte contient à la fin.\n Le reste est ce qui reste.",
][lang];

// Generic Tutorial strings.
export const tutorialTitle = [
  "Help with the level",
  "Hilfe zum Level",
  "Aide pour le niveau",
][lang];
export const tutorialButtonStartLevel = [
  "Let's go",
  "Los geht's",
  "Allons-y",
][lang];
export const tutorialButtonPreviousPage = [
  "Back",
  "Zurück",
  "Retour",
][lang];
export const tutorialButtonNextPage = [
  "Continue",
  "Weiter",
  "Continue",
][lang];

// Tutorial0Roman.jsx
export const tutorial0Roman1 = [
  "In this level you will practice converting old Roman numbers into decimal numbers.",
  "In diesem Level übst du, altrömische Zahlen in Dezimalzahlen umzuwandeln.",
  "Dans ce niveau, tu t'entraîneras à convertir les anciens chiffres romains en nombres décimaux.",
][lang];
export const tutorial0Roman2 = [
  "To this end you should write the solution into the input field.",
  "Dazu sollst du die Lösung in das Eingabefeld schreiben.",
  "Pour ce faire, tu dois écrire la solution dans le champ de saisie.",
][lang];

// Tutorial1Roman.jsx
export const tutorial1Roman1 = [
  "In this level you will practice converting decimal numbers into old Roman numbers.",
  "In diesem Level übst du, Dezimalzahlen in altrömische Zahlen umzuwandeln.",
  "Dans ce niveau, tu t'entraîneras à convertir les nombres décimaux en anciens chiffres romains.",
][lang];
export const tutorial1Roman2 = [
  "To this end, beneath each group of coins you should write the most fitting old Roman number.",
  "Dazu sollst du für jede Gruppe von Münzen die passende römische Zahl in das Eingabefeld schreiben.",
  "Pour ce faire, sous chaque groupe de pièces, tu dois écrire le chiffre romain ancien le plus approprié.",
][lang];
export const tutorial1Roman3 = [
  "For example, beneath a group of two coins of 10, you would write 'XX'.",
  "Zum Beispiel würdest du unter eine Gruppe bestehend aus zwei 10er Münzen 'XX' schreiben.",
  "Par exemple, sous un groupe de deux pièces de 10, tu écrirais 'XX'.",
][lang];

// Tutorial2Roman.jsx
export const tutorial2Roman1 = [
  "In this level you will learn how to divide using old Roman numerals.",
  "In diesem Level lernst du das Teilen mit altrömischen Zahlen.",
  "Dans ce niveau, tu apprendras à diviser en utilisant les anciens chiffres romains.",
][lang];
export const tutorial2Roman2 = [
  "The goal is to distribute all coins evenly among the rectangular boxes.",
  "Das Ziel ist es, alle Münzen gleichmässig auf die rechteckigen Boxen zu verteilen.",
  "Le but est de répartir toutes les pièces équitablement entre les boîtes rectangulaires.",
][lang];
export const tutorial2Roman3 = [
  "To do this, in each step you need to decide whether to distribute a coin, or whether you should first exchange it for smaller coins because there aren't enough coins of that type left for even distribution.",
  "Dazu musst du in jedem Schritt entscheiden, ob du eine Münze verteilst, oder ob du sie vorher in kleinere Münzen umtauschen solltest, weil es zum gleichmässigen Verteilen nicht mehr genug Münzen dieser Sorte gibt.",
  "Pour ce faire, à chaque étape, tu dois décider si tu distribues une pièce, ou si tu dois d'abord l'échanger contre des pièces plus petites car il n'y a plus assez de pièces de ce type pour une distribution égale.",
][lang];
export const tutorial2Roman4 = [
  "To distribute a coin into a box, drag it either with the mouse or (on tablets) with your finger into the box.",
  "Um eine Münze auf eine Box zu verteilen, ziehe sie entweder mit der Maus oder (auf Tablets) mit dem Finger in die Box.",
  "Pour distribuer une pièce dans une boîte, glisse-la soit avec la souris, soit (sur les tablettes) avec ton doigt dans la boîte.",
][lang];
export const tutorial2Roman5 = [
  "To exchange a coin type, click on the corresponding 'Exchange' button.",
  "Um eine Münzsorte umzutauschen, klicke auf den entsprechenden 'Tauschen'-Knopf.",
  "Pour échanger un type de pièce, clique sur le bouton 'Échanger' correspondant.",
][lang];
export const tutorial2Roman6 = [
  "When you have finished distributing the coins, you can read the result of the division from the individual boxes.",
  "Wenn du die Münzen fertig verteilt hast, kannst du das Ergebnis der Teilung aus den einzelnen Boxen ablesen.",
  "Lorsque tu as terminé de distribuer les pièces, tu peux lire le résultat de la division à partir des boîtes individuelles.",
][lang];
export const tutorial2Roman7 = [
  "Then write the result and the remainder (if any) into the input fields. Into the top row using old Roman numerals, and into the bottom row in decimal.",
  "Schreibe dann das Ergebnis und den Rest (falls vorhanden) in die Eingabefelder. In die obere Zeile in altrömischen Zahlen, und in die untere Zeile in Dezimal.",
  "Ensuite, écris le résultat et le reste (s'il y en a) dans les champs de saisie. Dans la ligne du haut en chiffres romains anciens, et dans la ligne du bas en décimal.",
][lang];

// Tutorial3Roman.jsx
export const tutorial3Roman1 = [
  "This level is the same as the previous one, but the numbers are bigger.",
  "Dieses Level funktioniert genau wie das vorige, nur sind die Zahlen jetzt grösser.",
  "Ce niveau est identique au précédent, mais les nombres sont plus grands.",
][lang];

// Tutorial4Roman.jsx
export const tutorial4Roman1 = [
  "In this level, you should manage without coins.",
  "In diesem Level sollst du ohne Münzen klarkommen.",
  "Dans ce niveau, tu devrais te débrouiller sans pièces.",
][lang];
export const tutorial4Roman2 = [
  "Fill in the input fields so that the calculation works out. The top row contains the division. The bottom row contains the corresponding multiplication.",
  "Fülle die Eingabefelder so aus, dass die Rechnung aufgeht. In der oberen Zeile steht die Durch-Rechnung. In der unteren Zeile steht die dazugehörige Mal-Rechnung.",
  "Remplis les champs de saisie pour que le calcul fonctionne. La ligne du haut contient la division. La ligne du bas contient la multiplication correspondante.",
][lang];
export const tutorial4Roman3 = [
  "Use only the old Roman numerals.",
  "Benutze ausschliesslich die altrömischen Zahlen.",
  "Utilise uniquement les anciens chiffres romains.",
][lang];

// Tutorial5Roman.jsx
export const tutorial5Roman1 = [
  "Now comes the hardest task.",
  "Jetzt kommt die schwierigste Aufgabe.",
  "Voici maintenant la tâche la plus difficile.",
][lang];
export const tutorial5Roman2 = [
  "Here you will learn how to easily divide large Roman numerals using tables, by breaking down a large division into many smaller divisions.",
  "Hier lernst du, wie du mithilfe von Tabellen auch grosse römische Zahlen einfach teilen kannst, indem du eine grosse Teilung in viele kleine Teilungen 'aufteilst'.",
  "Ici, tu apprendras à diviser facilement de grands chiffres romains en utilisant des tableaux, en décomposant une grande division en plusieurs petites divisions.",
][lang];
export const tutorial5Roman3 = [
  "There are 2 tables. The numbers in the tables tell you how many of the depicted coin type are to be distributed (left table) or are already distributed (right table).",
  "Es gibt 2 Tabellen. Die Zahlen in den Tabellen bedeuten, dass von der abgebildeten Münze entsprechend viele zu verteilen sind (linke Tabelle), bzw. bereits verteilt sind (rechte Tabelle).",
  "Il y a 2 tableaux. Les nombres dans les tableaux t'indiquent combien de pièces du type représenté doivent être distribuées (tableau de gauche) ou sont déjà distribuées (tableau de droite).",
][lang];
export const tutorial5Roman4 = [
  "On the left, you will always write the remainders, and on the right, always the results of the divisions.",
  "Links wirst du immer die Reste reinschreiben und rechts immer die Ergebnisse der Teilungen.",
  "À gauche, tu écriras toujours les restes, et à droite, toujours les résultats des divisions.",
][lang];
export const tutorial5Roman5 = [
  "You always divide the number above the empty field in the left table by the divisor.",
  "Du rechnest immer die Zahl, die in der linken Tabelle über dem leeren Feld steht, durch den Teiler.",
  "Tu divises toujours le nombre du tableau de gauche, qui se trouve au-dessus de la case vide, par le diviseur."
][lang];
export const tutorial5Roman6 = [
  "In this example, 7 : 5 = 1 remainder 2, so you will write '2' into the gap in the left table, and '1' into the right table.",
  "In diesem Beispiel ist 7 : 5 = 1 Rest 2, also schreibst du in die linke Tabelle '2' in die Lücke, und in die rechte Tabelle '1'.",
  "Dans cet exemple, 7 : 5 = 1 reste 2, donc tu écriras '2' dans l'espace vide du tableau de gauche, et '1' dans le tableau de droite.",
][lang];
export const tutorial5Roman7 = [
  "Sometimes it happens that the number you want to divide is smaller than the divisor. In this case, you have to exchange the coins for smaller ones.",
  "Manchmal kommt es vor, dass die Zahl, die du teilen willst, kleiner ist, als der Teiler. In diesem Fall musst du die Münzen in kleinere umtauschen.",
  "Il arrive parfois que le nombre que tu veux diviser soit plus petit que le diviseur. Dans ce cas, tu dois échanger les pièces contre des plus petites.",
][lang];
export const tutorial5Roman8 = [
  "You do this by writing the new number of coins of the respective type in the left table.",
  "Das tust du, indem du in der linken Tabelle die neue Anzahl Münzen der jeweiligen Sorte hinschreibst.",
  "Tu le fais en écrivant le nouveau nombre de pièces du type respectif dans le tableau de gauche.",
][lang];
export const tutorial5Roman9 = [
  "In this example you want to exchange two D-coins for C-coins, because 2 is not divisible by 5. Since two D-coins are worth 10 C-coins, you will add 10 to the 3 C-coins that are already available. Write 0 into the D field.",
  "In diesem Beispiel willst du zwei D-Münzen in C-Münzen umtauschen, weil 2 nicht durch 5 teilbar ist. Da zwei D-Münzen soviel wert sind wie 10 C-Münzen, rechnest du 10 zu den bereits vorhandenen 3 C-Münzen dazu. Bei D schreibst du 0 hin.",
  "Dans cet exemple, tu veux échanger deux pièces D contre des pièces C, car 2 n'est pas divisible par 5. Puisque deux pièces D valent 10 pièces C, tu ajouteras 10 aux 3 pièces C déjà disponibles. Écris 0 dans le champ D.",
][lang];
export const tutorial5Roman10 = [
  "Click on the 'Check line' button to verify your intermediate solutions.",
  "Klicke auf den 'Zeile prüfen'-Knopf, um deine Zwischenlösungen zu überprüfen.",
  "Clique sur le bouton 'Vérifie la ligne' pour vérifier tes solutions intermédiaires.",
][lang];
export const tutorial5Roman11 = [
  "When you are finished, you can read the result and the remainder from the bottom rows of the tables.",
  "Wenn du fertig bist, kannst du das Ergebnis und den Rest aus den untersten Zeilen der Tabellen ablesen.",
  "Lorsque tu as terminé, tu peux lire le résultat et le reste à partir des lignes inférieures des tableaux.",
][lang];
export const tutorial5Roman12 = [
  "Then write the result and the remainder once in old Roman numerals and once in decimal into the input fields below.",
  "Schreibe dann das Ergebnis und den Rest einmal in altrömischen Zahlen und einmal in Dezimal in die Eingabefelder unten.",
  "Ensuite, écris le résultat et le reste une fois en chiffres romains anciens et une fois en décimal dans les champs de saisie ci-dessous.",
][lang];

// Tutorial0Binary.jsx
export const tutorial0Binary1 = [
  "In this level you will practice converting binary numbers into decimal numbers.",
  "In diesem Level übst du, Binärzahlen in Dezimalzahlen umzuwandeln.",
  "Dans ce niveau, tu t'entraîneras à convertir les nombres binaires en nombres décimaux.",
][lang];
export const tutorial0Binary2 = [
  "To this end you should add the values of all binary coins marked with a One.",
  "Dazu sollst du die Werte aller Binärmünzen, bei denen eine Eins steht, addieren.",
  "Pour ce faire, tu dois additionner les valeurs de toutes les pièces binaires marquées d'un Un.",
][lang];
export const tutorial0Binary3 = [
  "Beneath each binary coin, write either its value or a Zero. Then write down the sum.",
  "Schreibe unter jede Münze entweder ihren Wert oder eine Null, und am Schluss die Summe.",
  "Sous chaque pièce binaire, écris soit sa valeur, soit un Zéro. Ensuite, écris la somme.",
][lang];

// Tutorial1Binary.jsx
export const tutorial1Binary1 = [
  "In this level you will practice converting decimal numbers into binary numbers.",
  "In diesem Level übst du, Dezimalzahlen in Binärzahlen umzuwandeln.",
  "Dans ce niveau, tu t'entraîneras à convertir les nombres décimaux en nombres binaires.",
][lang];
export const tutorial1Binary2 = [
  "To do this, drag the correct coins with your mouse or (on tablets) with your finger into the lower box.",
  "Ziehe dazu die richtigen Münzen mit der Maus oder (auf Tablets) mit dem Finger in die untere Box.",
  "Pour ce faire, glisse les bonnes pièces avec ta souris ou (sur les tablettes) avec ton doigt dans la boîte inférieure.",
][lang];
export const tutorial1Binary3 = [
  "You can also put the coins back if you made a mistake.",
  "Du kannst die Münzen auch wieder zurücklegen, wenn du einen Fehler gemacht hast.",
  "Tu peux également remettre les pièces en place si tu as fait une erreur.",
][lang];

// Tutorial2Binary.jsx
export const tutorial2Binary1 = [
  "In this level you will learn how to divide using binary numbers.",
  "In diesem Level lernst du das Teilen mit Binärzahlen.",
  "Dans ce niveau, tu apprendras à diviser en utilisant les nombres binaires.",
][lang];
export const tutorial2Binary2 = [
  "The goal is to distribute all coins evenly among the rectangular boxes.",
  "Das Ziel ist es, alle Münzen gleichmässig auf die rechteckigen Boxen zu verteilen.",
  "Le but est de répartir toutes les pièces équitablement entre les boîtes rectangulaires.",
][lang];
export const tutorial2Binary3 = [
  "To do this, in each step you need to decide whether to distribute a coin, or whether you should first exchange it for smaller coins because there aren't enough coins of that type left for even distribution.",
  "Dazu musst du in jedem Schritt entscheiden, ob du eine Münze verteilst, oder ob du sie vorher in kleinere Münzen umtauschen solltest, weil es zum gleichmässigen Verteilen nicht mehr genug Münzen dieser Sorte gibt.",
  "Pour ce faire, à chaque étape, tu dois décider si tu distribues une pièce, ou si tu dois d'abord l'échanger contre des pièces plus petites car il n'y a plus assez de pièces de ce type pour une distribution égale.",
][lang];
export const tutorial2Binary4 = [
  "To distribute a coin type into the boxes, click on the corresponding 'Distribute' button.",
  "Um eine Münzesorte auf die Boxen zu verteilen, klicke auf den entsprechenden 'Verteilen'-Knopf.",
  "Pour distribuer un type de pièce dans les boîtes, clique sur le bouton 'Distribuer' correspondant.",
][lang];
export const tutorial2Binary5 = [
  "To exchange a coin type, click on the corresponding 'Exchange' button.",
  "Um eine Münzsorte umzutauschen, klicke auf den entsprechenden 'Tauschen'-Knopf.",
  "Pour échanger un type de pièce, clique sur le bouton 'Échanger' correspondant.",
][lang];
export const tutorial2Binary6 = [
  "When you have finished distributing the coins, you can read the result of the division from the individual boxes.",
  "Wenn du die Münzen fertig verteilt hast, kannst du das Ergebnis der Teilung aus den einzelnen Boxen ablesen.",
  "Lorsque tu as terminé de distribuer les pièces, tu peux lire le résultat de la division à partir des boîtes individuelles.",
][lang];
export const tutorial2Binary7 = [
  "Then write the result and the remainder (if any) into the input fields. Into the top row in binary, and into the bottom row in decimal.",
  "Schreibe dann das Ergebnis und den Rest (falls vorhanden) in die Eingabefelder. In die obere Zeile in Binär, und in die untere Zeile in Dezimal.",
  "Ensuite, écris le résultat et le reste (s'il y en a) dans les champs de saisie. Dans la ligne du haut en binaire, et dans la ligne du bas en décimal.",
][lang];

// Tutorial3Binary.jsx
export const tutorial3Binary1 = [
  "This level is almost the same as the previous one, but instead of using a 'Distribute' button you have to drag the coins into the boxes yourself.",
  "Dieses Level funktioniert fast wie das vorige, nur statt einen 'Verteilen'-Knopf zu verwenden musst du diesmal die Münzen selber in die Boxen ziehen.",
  "Ce niveau est presque identique au précédent, mais au lieu d'utiliser un bouton 'Distribuer', tu dois glisser toi-même les pièces dans les boîtes.",
][lang];

// Tutorial4Binary.jsx
export const tutorial4Binary1 = [
  "In the next two levels, the goal is to learn about a special feature of the binary system when multiplying or dividing by 2.",
  "In den nächsten beiden Levels geht es darum, eine Besonderheit des Binärsystems kennenzulernen, wenn man mal oder durch 2 rechnet.",
  "Dans les deux prochains niveaux, l'objectif est d'apprendre une particularité du système binaire lors de la multiplication ou de la division par 2.",
][lang];
export const tutorial4Binary2 = [
  "This level has only one task instead of three. Afterwards, you can proceed to the next level.",
  "Dieses Level hat statt drei nur eine Aufgabe. Danach kannst du zum nächsten Level.",
  "Ce niveau n'a qu'une seule tâche au lieu de trois. Ensuite, tu pourras passer au niveau suivant.",
][lang];

// Tutorial5Binary.jsx
export const tutorial5Binary1 = [
  "This level works exactly like the previous one, only this time you are dividing.",
  "Dieses Level funktioniert genau wie das vorige, nur teilst du diesmal.",
  "Ce niveau fonctionne exactement comme le précédent, seulement cette fois, tu divises.",
][lang];
export const tutorial5Binary2 = [
  "This level also has only one task.",
  "Auch dieses Level hat nur eine Aufgabe.",
  "Ce niveau n'a également qu'une seule tâche.",
][lang];

// Tutorial6Binary.jsx
export const tutorial6Binary1 = [
  "In this level, you should apply the trick you just learned. But this time without coins.",
  "In diesem Level sollst du den Trick von eben anwenden. Aber diesmal ohne Münzen.",
  "Dans ce niveau, tu dois appliquer l'astuce que tu viens d'apprendre. Mais cette fois sans pièces.",
][lang];

// Tutorial7Binary.jsx
export const tutorial7Binary1 = [
  "Now comes the hardest task.",
  "Jetzt kommt die schwierigste Aufgabe.",
  "Voici maintenant la tâche la plus difficile.",
][lang];
export const tutorial7Binary2 = [
  "Here you will learn how to easily divide large binary numbers using tables, by breaking down a large division into many smaller divisions.",
  "Hier lernst du, wie du mithilfe von Tabellen auch grosse Binärzahlen einfach teilen kannst, indem du eine grosse Teilung in viele kleine Teilungen 'aufteilst'.",
  "Ici, tu apprendras à diviser facilement de grands nombres binaires en utilisant des tableaux, en décomposant une grande division en plusieurs petites divisions.",
][lang];
export const tutorial7Binary3 = [
  "There are 2 tables. The numbers in the tables tell you how many of the depicted coin type are to be distributed (left table) or are already distributed (right table).",
  "Es gibt 2 Tabellen. Die Zahlen in den Tabellen bedeuten, dass von der abgebildeten Münze entsprechend viele zu verteilen sind (linke Tabelle), bzw. bereits verteilt sind (rechte Tabelle).",
  "Il y a 2 tableaux. Les nombres dans les tableaux t'indiquent combien de pièces du type représenté doivent être distribuées (tableau de gauche) ou sont déjà distribuées (tableau de droite).",
][lang];
export const tutorial7Binary4 = [
  "On the left, you will always write the remainders, and on the right, always the results of the divisions.",
  "Links wirst du immer die Reste reinschreiben und rechts immer die Ergebnisse der Teilungen.",
  "À gauche, tu écriras toujours les restes, et à droite, toujours les résultats des divisions.",
][lang];
export const tutorial7Binary5 = [
  "You always divide the number above the empty field in the left table by the divisor.",
  "Du rechnest immer die Zahl, die in der linken Tabelle über dem leeren Feld steht, durch den Teiler.",
  "Tu divises toujours le nombre du tableau de gauche, qui se trouve au-dessus de la case vide, par le diviseur."
][lang];
export const tutorial7Binary6 = [
  "In this example, 3 : 3 = 1 remainder 0, so you will write '0' into the gap in the left table, and '1' into the right table.",
  "In diesem Beispiel ist 3 : 3 = 1 Rest 0, also schreibst du in die linke Tabelle '0' in die Lücke, und in die rechte Tabelle '1'.",
  "Dans cet exemple, 3 : 3 = 1 reste 0, donc tu écriras '0' dans l'espace vide du tableau de gauche, et '1' dans le tableau de droite.",
][lang];
export const tutorial7Binary7 = [
  "Sometimes it happens that the number you want to divide is smaller than the divisor. In this case, you have to exchange the coins for smaller ones.",
  "Manchmal kommt es vor, dass die Zahl, die du teilen willst, kleiner ist, als der Teiler. In diesem Fall musst du die Münzen in kleinere umtauschen.",
  "Il arrive parfois que le nombre que tu veux diviser soit plus petit que le diviseur. Dans ce cas, tu dois échanger les pièces contre des plus petites.",
][lang];
export const tutorial7Binary8 = [
  "You do this by writing the new number of coins of the respective type in the left table.",
  "Das tust du, indem du in der linken Tabelle die neue Anzahl Münzen der jeweiligen Sorte hinschreibst.",
  "Tu le fais en écrivant le nouveau nombre de pièces du type respectif dans le tableau de gauche.",
][lang];
export const tutorial7Binary9 = [
  "In this example, you want to exchange a 16-coin for 8-coins because 1 is not divisible by 3. Since a 16-coin is worth as much as two 8-coins, you add 2 to the already existing 8-coins (in this case there were none). For the 16-coins, you write 0.",
  "In diesem Beispiel willst du eine 16er Münze in 8er Münzen umtauschen, weil 1 nicht durch 3 teilbar ist. Da eine 16er Münze soviel wert ist wie zwei 8er Münzen, rechnest du 2 zu den bereits vorhandenen 8er Münzen dazu (in diesem Fall gab es keine). Bei den 16er Münzen schreibst du 0 hin.",
  "Dans cet exemple, tu veux échanger une pièce de 16 contre des pièces de 8 parce que 1 n'est pas divisible par 3. Comme une pièce de 16 vaut autant que deux pièces de 8, tu ajoutes 2 aux pièces de 8 déjà existantes (dans ce cas, il n'y en avait aucune). Pour les pièces de 16, tu écris 0."
][lang];
export const tutorial7Binary10 = [
  "Click on the 'Check line' button to verify your intermediate solutions.",
  "Klicke auf den 'Zeile prüfen'-Knopf, um deine Zwischenlösungen zu überprüfen.",
  "Clique sur le bouton 'Vérifie la ligne' pour vérifier tes solutions intermédiaires.",
][lang];
export const tutorial7Binary11 = [
  "When you are finished, you can read the result and the remainder from the bottom rows of the tables.",
  "Wenn du fertig bist, kannst du das Ergebnis und den Rest aus den untersten Zeilen der Tabellen ablesen.",
  "Lorsque tu as terminé, tu peux lire le résultat et le reste à partir des lignes inférieures des tableaux.",
][lang];
export const tutorial7Binary12 = [
  "Then write the result and the remainder once in binary and once in decimal into the input fields below.",
  "Schreibe dann das Ergebnis und den Rest einmal in Binär und einmal in Dezimal in die Eingabefelder unten.",
  "Ensuite, écris le résultat et le reste une fois en binaire et une fois en décimal dans les champs de saisie ci-dessous.",
][lang];

// Tutorial0Maya.jsx
export const tutorial0Maya1 = [
  "In this level you will practice converting 'Maya' hieroglyphs into decimal numbers.",
  "In diesem Level übst du, 'Maya'-Hieroglyphen in Dezimalzahlen umzuwandeln.",
  "Dans ce niveau, tu t'entraîneras à convertir les hiéroglyphes 'Mayas' en nombres décimaux.",
][lang];
export const tutorial0Maya2 = [
  "Note:",
  "Beachte:",
  "Remarque : ",
][lang];

// Tutorial1Maya.jsx
export const tutorial1Maya1 = [
  "In this level you will practice converting decimal numbers into 'Maya' hieroglyphs.",
  "In diesem Level übst du, Dezimalzahlen in 'Maya'-Hieroglyphen umzuwandeln.",
  "Dans ce niveau, tu t'entraîneras à convertir les nombres décimaux en hiéroglyphes 'Mayas'.",
][lang];
export const tutorial1Maya2 = [
  "To do this, drag the correct amount of Maya items with your mouse or (on tablets) your finger into the box.",
  "Ziehe dazu die richtige Anzahl Maya-Gegenstände mit der Maus oder (auf Tablets) mit dem Finger in die Box.",
  "Pour ce faire, glisse la bonne quantité d'objets Mayas avec ta souris ou (sur les tablettes) avec ton doigt dans la boîte.",
][lang];
export const tutorial1Maya3 = [
  "You can also put the items back if you made a mistake.",
  "Du kannst die Gegenstände auch wieder zurücklegen, wenn du einen Fehler gemacht hast.",
  "Tu peux également remettre les objets en place si tu as fait une erreur.",
][lang];

// Tutorial2Maya.jsx
export const tutorial2Maya1 = [
  "In this level you will learn how to divide using 'Maya' hieroglyphs.",
  "In diesem Level lernst du das Teilen mit 'Maya'-Hieroglyphen.",
  "Dans ce niveau, tu apprendras à diviser en utilisant les hiéroglyphes 'Mayas'.",
][lang];
export const tutorial2Maya2 = [
  "The goal is to distribute all 'Maya' items evenly among the rectangular boxes.",
  "Das Ziel ist es, alle 'Maya'-Gegenstände gleichmässig auf die rechteckigen Boxen zu verteilen.",
  "Le but est de répartir tous les objets 'Mayas' équitablement entre les boîtes rectangulaires.",
][lang];
export const tutorial2Maya3 = [
  "To do this, in each step you need to decide whether to distribute an item, or whether you should first exchange it for smaller 'Maya' items because there aren't enough items of that type left for even distribution.",
  "Dazu musst du in jedem Schritt entscheiden, ob du einen Gegenstand verteilst, oder ob du ihn vorher in kleinere 'Maya'-Gegenstände umtauschen solltest, weil es zum gleichmässigen Verteilen nicht mehr genug Gegenstände dieser Sorte gibt.",
  "Pour ce faire, à chaque étape, tu dois décider si tu distribues un objet, ou si tu dois d'abord l'échanger contre des objets 'Mayas' plus petits car il n'y a plus assez d'objets de ce type pour une distribution égale.",
][lang];
export const tutorial2Maya4 = [
  "To distribute an item into a box, drag it either with the mouse or (on tablets) with your finger into the box.",
  "Um einen Gegenstand auf eine Box zu verteilen, ziehe ihn entweder mit der Maus oder (auf Tablets) mit dem Finger in die Box.",
  "Pour distribuer un objet dans une boîte, glisse-le soit avec la souris, soit (sur les tablettes) avec ton doigt dans la boîte.",
][lang];
export const tutorial2Maya5 = [
  "To exchange an item type, click on the corresponding 'Exchange' button.",
  "Um eine Gegenstandssorte umzutauschen, klicke auf den entsprechenden 'Tauschen'-Knopf.",
  "Pour échanger un type d'objet, clique sur le bouton 'Échanger' correspondant.",
][lang];
export const tutorial2Maya6 = [
  "When you have finished distributing the items, you can read the result of the division from the individual boxes.",
  "Wenn du die Gegenstände fertig verteilt hast, kannst du das Ergebnis der Teilung aus den einzelnen Boxen ablesen.",
  "Lorsque tu as terminé de distribuer les objets, tu peux lire le résultat de la division à partir des boîtes individuelles.",
][lang];
export const tutorial2Maya7 = [
  "Then complete the equation for the division you just performed by filling in the input fields.",
  "Vervollständige dann die Gleichung für die Teilung, die du eben durchgeführt hast, indem du die Eingabefelder ausfüllst.",
  "Ensuite, complète l'équation pour la division que tu viens d'effectuer en remplissant les champs de saisie.",
][lang];

// Tutorial3Maya.jsx
export const tutorial3Maya1 = [
  "This level works exactly like the previous one, only this time the division will have a remainder.",
  "Dieses Level funktioniert genau wie das vorige, nur bleibt diesmal nach der Teilung ein Rest übrig.",
  "Ce niveau fonctionne exactement comme le précédent, seulement cette fois la division aura un reste.",
][lang];

// Tutorial4Maya.jsx
export const tutorial4Maya1 = [
  "Pfiffikus felt corn and baskets are too tedious to use with larger numbers, and introduced a new symbol: the cart.",
  "Der Pfiffikus fand die Darstellung grösserer Zahlen mit Maiskolben und Körben zu umständlich, und hat ein neues Symbol eingeführt: den Karren.",
  "Pfiffikus trouvait que le maïs et les paniers étaient trop pénibles à utiliser avec de grands nombres, et il a introduit un nouveau symbole : le chariot.",
][lang];
export const tutorial4Maya2 = [
  "Try dividing using the new symbol.",
  "Versuche dich nun am Teilen mit dem neuen Symbol.",
  "Essaie maintenant de diviser en utilisant le nouveau symbole.",
][lang];